interface ValidationModalProps {
  open: boolean;
  errors: string[];
  onClose: () => void;
}

export default function ValidationModal({ open, errors, onClose }: ValidationModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      <div
        className="relative w-full max-w-md rounded-2xl bg-white p-6 border border-gray-100"
        style={{ animation: 'modal-in 0.2s ease-out' }}
      >
        <div className="flex items-start gap-3 mb-4">
          <div
            className="w-11 h-11 flex items-center justify-center rounded-full flex-shrink-0"
            style={{ backgroundColor: 'rgba(46,125,107,0.1)' }}
          >
            <i className="ri-error-warning-line text-xl" style={{ color: '#2E7D6B' }}></i>
          </div>
          <div className="flex-1 pt-0.5">
            <h3 className="text-base font-bold text-gray-900 mb-1">입력되지 않은 항목이 있어요</h3>
            <p className="text-xs text-gray-500 leading-relaxed">
              아래 항목을 확인한 후 모두 입력해 주세요.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 cursor-pointer transition-colors flex-shrink-0"
          >
            <i className="ri-close-line"></i>
          </button>
        </div>

        <ul className="space-y-2.5 mb-6 max-h-64 overflow-y-auto">
          {errors.map((err, i) => (
            <li key={i} className="flex items-start gap-2.5 text-sm text-gray-700">
              <i
                className="ri-close-circle-line text-base mt-0.5 flex-shrink-0"
                style={{ color: '#e5484d' }}
              ></i>
              <span className="leading-relaxed">{err}</span>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={onClose}
          className="w-full py-3 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
          style={{ backgroundColor: '#2E7D6B' }}
        >
          확인
        </button>
      </div>
    </div>
  );
}